import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Neuro () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.neurologicalMotor.name}
            options={[
              {
                label: 'Motor Grossly WNL',
                value: 'Motor Grossly WNL'
              },
              {
                label: 'Weakness',
                value: 'Weakness'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.neurologicalSensory.name}
            options={[
              {
                label: 'Sensory Grossly WNL',
                value: 'Sensory Grossly WNL'
              },
              {
                label: 'Sensory Deficit',
                value: 'Sensory Deficit'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.neurologicalGait.name}
            options={[
              {
                label: 'Normal Gait',
                value: 'Normal Gait'
              },
              {
                label: 'Limited Gait',
                value: 'Limited Gait'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.neurologicalCranialNerves.name}
            options={[
              {
                label: 'Cranial Nerves II-XII Intact',
                value: 'Cranial Nerves II-XII Intact'
              },
              {
                label: 'Cranial Nerve Deficit',
                value: 'Cranial Nerve Deficit'
              }
            ]}
          />
        </div>
        <div className='col-xs-12 margin-top'>
          <CheckboxInput {...PEQuestionnaire.neurologicalOther} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.neurologicalOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Neuro
